module.exports = __webpack_public_path__ + "img/sulam_no.8d481bd8.png";